'use strict';

//----------------------------------------------------------------------
//
// This source file is part of the Folktale project.
//
// Licensed under MIT. See LICENCE for full licence information.
// See CONTRIBUTORS for the list of contributors to the project.
//
//----------------------------------------------------------------------

/*~
 * stability: experimental
 * name: module folktale/adt/union/derivations
 */
module.exports = {
  serialization: require('./serialization'),
  equality: require('./equality'),
  debugRepresentation: require('./debug-representation')
};


//////////////////
// WEBPACK FOOTER
// ./~/folktale/adt/union/derivations/index.js
// module id = 268
// module chunks = 34471704633725 35783957827783 216468464745311